import { Controller } from "@hotwired/stimulus"
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "text", "form", "speaker", "controls", "modal", "confettiContainer",
                     "interviewSubject", "speakers" ]
  static values = {
    multiple: String
  }

  connect() {
    // console.log("Hello, Stimulus from Stories Speaker Identification!", this.element)
    // console.log(this.textTarget)
    // console.log(this.textTarget.innerText);
    // console.log(this.formTarget);

    // loop through an unknown number of speakers and wrap them in a span for later replacement
    if (this.hasTextTarget && this.textTarget.innerText.includes('speaker_')) {

      let identifiedSpeakers = 0;
      for(let i = 1; i < 11; i++) {
        if (this.textTarget.innerText.includes(`speaker_${i}`)) {
          this.textTarget.innerHTML = this.textTarget.innerHTML.replaceAll(`speaker_${i}`, `<span class='speaker_${i} font-fanword-bold'>speaker_${i}</span>`)
          identifiedSpeakers++;
        }
      }

      // update the hidden input with the number of speakers that were identified if we are on transcriptions page
      if (this.hasSpeakersTarget) {
        this.speakersTarget.value = identifiedSpeakers;
      }

    } else {

      if (this.hasControlsTarget) {
        this.controlsTarget.style.display = 'none';
      }

    }

    // for use in the FTP
    if (this.hasModalTarget && this.hasTextTarget) {
      if (localStorage.getItem('interviewer_speaker_identification') === 'true') {
        localStorage.removeItem('interviewer_speaker_identification');

        this.confettiContainerTarget.classList.remove('d-none');
        this.confettiContainerTarget.classList.add('d-block');

        const hoorayModal = new bootstrap.Modal(this.modalTarget);

        hoorayModal.show();

        const showConfetti = () => {
          const confetti = document.createElement("div");
          confetti.textContent = "🌭";
          confetti.classList.add("confetti");
          confetti.style.left = Math.random() * innerWidth + "px";
          this.confettiContainerTarget.appendChild(confetti);

          setTimeout(() => {
            confetti.remove();
          }, 3000);
        };

        const confettiLoop = setInterval(() => {
          showConfetti();
        }, 200);

        this.modalTarget.addEventListener('hidden.bs.modal', () => {
          clearInterval(confettiLoop);

          this.confettiContainerTarget.classList.remove('d-block');
          this.confettiContainerTarget.classList.add('d-none');
        })

      }
    }

    // if the transcript has more than 2 speakers, make dynamic TEXT fields
    if (this.multipleValue) {
      // console.log('Multiple speakers detected');
      for(let i = 1; i < 10; i++) {
        if (this.textTarget.innerText.includes(`speaker_${i}`)) {
          const formControl = `<div class="row mb-4">
            <div class="col-12 col-md-6">
              <label for="speaker_${i}_role" class="form-label">Speaker ${i} Role</label>
              <select class="form-select fanword-border fanword-border-radius  p-3" id="speaker_${i}_role" data-action="input->stories-speaker-identification#updateSpeaker" data-stories-speaker-identification-target="speaker" data-stories-speaker-identification-id-param="${i}">
                <option value="">Select Role</option>
                <option value="Interviewer">Interviewer</option>
                <option value="Respondent">Respondent</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div class="col-12 col-md-6">
              <label for="speaker_${i}_name" class="form-label">Speaker ${i} Name</label>
              <input type="text" class="form-control fanword-border fanword-border-radius p-3" id="speaker_${i}_name" data-action="input->stories-speaker-identification#updateSpeaker" data-stories-speaker-identification-target="speaker" data-stories-speaker-identification-id-param="${i}">
            </div>
          </div>`;
          this.controlsTarget.innerHTML += formControl;
        }
      }
    }

  }

  updateSpeaker(event) {
    // console.log('Updating speaker text', event);

    if (this.multipleValue) {

      const id = event.params.id;

      const role = this.speakerTargets.find(elm => elm.id === `speaker_${id}_role`).value;
      const name = this.speakerTargets.find(elm => elm.id === `speaker_${id}_name`).value;

      this.replaceSpeakerLabel(id, role, name);

    } else {

      const id = event.params.id;
      const text = event.target.value;
      this.replaceSpeakerLabel(id, null, text);

    }

  }

  replaceSpeakerLabel(id, role = undefined, name = undefined) {
    // console.log('Updating speaker text', id, role, name);
    // this.textTarget.innerHTML = newText;

    let text = '';
    if (role && name) {
      text = `${name} (${role})`;
    } else if (name) {
      text = `${name}`;
    } else if (role) {
      text = `(${role})`;
    }

    document.querySelectorAll(`.speaker_${id}`).forEach(elm => elm.innerText = text);
  }

  submitForm(event) {

    // if subject text input is present, make sure they fill it out!
    if (this.hasInterviewSubjectTarget && this.interviewSubjectTarget.value === '') {
      this.interviewSubjectTarget.classList.add('is-invalid');
      this.interviewSubjectTarget.focus();
      createAlert('danger', 'Please enter the subject of the interview');
      return;
    }

    const input = document.createElement("textarea");
    input.setAttribute("name", event.target.dataset.formElement);
    input.innerHTML = this.textTarget.textContent.trim();
    input.style.display = 'none';
    this.formTarget.appendChild(input);

    if (this.hasModalTarget) {
      localStorage.setItem('interviewer_speaker_identification', 'true');
    }

    this.formTarget.submit();
  }

}

